<div class='exem-table grid'>
  <h5 class='col-12 font-bold'>EXEMPLIFICARE</h5>
  <table class='col-12'>
    <tr>
      <td colspan='3' class='col-6'>Suma economisită pentru pensie</td>
      <td colspan='2' class='col-6'>2.400 Lei</td>
    </tr>
    <tr>
      <td colspan='3'>Frecvență</td>
      <td colspan='2'>Anual</td>
    </tr>
    <tr>
      <td colspan='3'>Orizontul de timp</td>
      <td colspan='2'>30 de ani</td>
    </tr>
    <tr>
      <td colspan='3'>Rată de randament<sup>*</sup></td>
      <td colspan='2'>6,74% p.a.</td>
    </tr>
    <tr>
      <td colspan='3'>Total contribuții</td>
      <td colspan='2'>72.000 Lei</td>
    </tr>
    <tr>
      <td colspan='3'>Suma finală/ Valoarea activului net</td>
      <td colspan='2'>231.838 Lei</td>
    </tr>
    <tr>
      <td>Plată unică</td>
      <td colspan='2' class='different-pink'>208.890 Lei</td>
      <td class='different-pink'>Impozit pe venit</td>
      <td class='different-pink'>22.948 Lei</td>
    </tr>
    <tr>
      <td rowspan='2'>Plăți eșalonate</td>
      <td class='different-pink'>59 rate</td>
      <td class='different-pink'>3.895,51 Lei</td>
      <td rowspan='2' class='different-pink'>Impozit pe venit</td>
      <td rowspan='2' class='different-pink border-radius-25'>11.148 Lei</td>
    </tr>
    <tr>
      <td class='different-pink'>Ultima rată</td>
      <td class='different-pink'>2.003,11 Lei</td>
    </tr>
  </table>
  <div class='col-12'>
    <p><sup>*</sup>Rata medie anuală de randament pentru fondul de pensii facultative AZT MODERATO pentru perioada
      31.12.2008-29.12.2023, considerând contribuții plătite o dată pe an și convertite în unități de fond în ultima zi
      lucrătoare a fiecărui an. Performanțele anterioare nu reprezintă o garanție a performanțelor viitoare.</p>
  </div>
</div>
